export class Constants {
  public static authPrefix = 'auth';
}

export const AppRoles = {
  Admin: 'Admin',
  UserAdmin: 'UserAdmin',
  Developer: 'Developer',
  BetaUser: 'BetaUser',
  AdminJr: 'AdminJr',
  Checker: 'Checker',
  Drafter: 'Drafter',
  EquipmentOwner: 'EquipmentOwner',
  ProjectManager: 'ProjectManager',
  Manager: 'Manager',
  PartyChief: 'PartyChief',
  SurveyAssistant: 'SurveyAssistant',
  Client: 'Client',
  MunicipalOfficeReporting: 'MunicipalOfficeReporting',
  BankedTime: 'BankedTime',
  AccountingAdmin: 'AccountingAdmin',
  SafetyManagement: 'SafetyManagement',
  OfficeTimeApprover: 'OfficeTimeApprover',
  SupervisorOfficeTimeApprover: 'SupervisorOfficeTimeApprover',
  ProductionStatusReport: 'ProductionStatusReport',
  QuickLinkManagement: 'QuickLinkManagement',
  PurchaseOrderOnly: 'PurchaseOrderOnly',
  ProductionStaff: 'ProductionStaff',
  VendorAdmin: 'VendorAdmin',
  OfficeEquipmentManagement: 'OfficeEquipmentManagement',
  FieldTimeApprover: 'FieldTimeApprover',
  TimesheetLockedOut: 'TimesheetLockedOut',
  Gis: 'GIS'
};

export const AllAccessRoles = [AppRoles.Developer];
